

const Footer=()=>{
    return(
        <>
        <div className="h-[100px] bg-primary text-white text-center flex items-center justify-center">
            <div className="container">
                <p className="text-sm"> Copyright © Ecommerce 2024 All right recived</p>
           
            </div>
</div>
        
        </>
    )
}
export default Footer;